import { useRef } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styled from 'styled-components';
import LowQualityWarning from "./LowQualityWarning";
import ManualHighQualityWarning from "./ManualHighQualityWarning";
import { jsx as _jsx } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1i0fjcl-0"
})(["\n  left: 50%;\n  width: 380px;\n  min-height: 174px;\n  &.is-open {\n    visibility: visible;\n    opacity: 1;\n    transition: ", ";\n  }\n  &.is-closed {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s 150ms,\n      ", ";\n  }\n  & span,\n  button {\n    user-select: none;\n    white-space: nowrap;\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.transition(['opacity', 'transform', 'min-width']);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition(['opacity', 'transform', 'min-width']);
});
var PopperWarning = function PopperWarning(_ref3) {
  var selector = _ref3.selector,
    isSm = _ref3.isSm,
    currentQualityWarning = _ref3.currentQualityWarning,
    onDismiss = _ref3.onDismiss;
  var containerRef = useRef(null);
  var node = document.querySelector(selector);
  if (node) {
    return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(Wrapper, {
      "data-testid": "popper-quality-warning",
      className: cn(currentQualityWarning ? 'is-open' : 'is-closed', 'absolute flex flex-col text-left z-5 bg-base-main-80 p-16 rounded-5'),
      style: {
        bottom: isSm ? '94px' : '68px',
        transform: "translateX(-".concat(isSm ? 30 : 70, "%)")
      },
      ref: containerRef,
      children: currentQualityWarning && (currentQualityWarning === 'low-quality' ? /*#__PURE__*/_jsx(LowQualityWarning, {
        onDismiss: onDismiss
      }) : /*#__PURE__*/_jsx(ManualHighQualityWarning, {
        onDismiss: onDismiss
      }))
    }), node);
  }
  return null;
};
export default PopperWarning;